import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UtilityBillsDashboardPgComponent } from './utility-bills-dashboard-pg/utility-bills-dashboard-pg';

const routes: Routes = [
  {
    path: '',
    component: UtilityBillsDashboardPgComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerReportsPgsRoutingModule { }
